class Http {
  public static accessToken?: string;
}

export default Http;
